// import React from 'react';
// import PropTypes from 'prop-types';
// import _ from 'lodash';
//
// import icons from '../../../utils/icons';
//
// const DEFAULT_ICON = icons.armchair;
//
// class ItemTypeIcon extends React.Component {
//   static propTypes = {
//     type: PropTypes.object.isRequired,
//   };
//
//   render() {
//     const { type } = this.props;
//     const src = icons[type.icon];
//     return (
//       <img src={src || DEFAULT_ICON} {..._.omit(this.props, ['type', 'src'])} alt={type.name}/>
//     );
//   }
// }
//
// export default ItemTypeIcon;



// WEBPACK FOOTER //
// ./src/components/Common/ItemTypeIcon/index.js